import { Redirect } from "react-router-dom";
import SessionChecker from "../pages/SSO/SessionChecker";
import Storage from "../services/Storage";

const NotFound = () => {
    const storage = new Storage();
    return (
        <>
            {storage.token() ? <SessionChecker /> : <Redirect to='/login' />}
        </>
    );
}

export default NotFound;